import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '@environments/environment';
import { ILoginResponse, IManagementGroup, IResponse } from '@interfaces/index';
import { LibNotificationComponent } from '@ui-components/notification';
import { AppRoutingService, SESSION_COOKIE_MAX_AGE_MS } from '@ui-components/services';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  public loading = true;

  constructor(
    protected _app_routing_service: AppRoutingService,
    protected _cookie_service: CookieService,
    private _snack_bar: MatSnackBar
  ) {}

  notify(message: string, status: string) {
    this._snack_bar.openFromComponent(LibNotificationComponent, {
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
      panelClass: 'lib-notification',
      data: {
        message,
        status
      },
      duration: 3000
    });
  }

  handleLoginResponse(response: IResponse<ILoginResponse>) {
    if (response.code === 200) {
      this.setCookies(response.data);
      this._app_routing_service.goToAssessments();
    } else {
      this.setLoadingState(false);
    }
  }

  handleLoginError(message?: string) {
    this.setLoadingState(false);
    this.notify(message || 'Login failed. Please try again.', 'error');
  }

  setCookies(data: ILoginResponse) {
    const { access_token, org_id, person_id } = data;
    const expires = new Date(Date.now() + SESSION_COOKIE_MAX_AGE_MS);
    const secure = location.protocol === 'https:';
    const set = (name: string, value: string) =>
      this._cookie_service.set(name, value, expires, '/', environment.domain, secure, 'Lax');

    set('access_token', access_token);
    set('org_id', String(org_id));
    set('person_id', String(person_id));
  }

  setLoadingState(state: boolean) {
    this.loading = state;
  }
}
